import './TextComps.scss';

type Props = {
  children: React.ReactElement;
  className?: string;
};

export const Subtitle = ({ children, className }: Props) => {
  return <h3 className={`tm-subtitle ${className ? className : ''}`}>{children}</h3>;
};

export default Subtitle;
